import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

function normalizarParaVisualizar(pedido) {

  var itens = [];

  for (var i = 0; i < pedido.itensPedidoCompra.length; i++) {
    if (pedido.itensPedidoCompra[i].quantidade > 0)
      itens.push(pedido.itensPedidoCompra[i])
  }

  pedido.itensPedidoCompra = itens;

  pedido.itensPedidoCompra.map(item => {
      item.quantidade = converterMoeda.paraReal(item.quantidade);
      item.quantidadeCancelada = converterMoeda.paraReal(item.quantidadeCancelada);
      item.valorUnitario = converterMoeda.paraReal(item.valorUnitario);
      item.ipiItemPedido = converterMoeda.paraReal(item.ipiItemPedido);
      item.descontoDinheiro = converterMoeda.paraReal(item.descontoDinheiro);
  });

    pedido.dataVencimento = '';

  return pedido;
}

async function normalizarParaSalvar(pedido) {
    if (pedido.dataPedido) {
        pedido.dataPagamento = await formatarData.paraNumero(pedido.dataPedido);
    }

    if (pedido.dataEntrega) {
        pedido.dataEntrega = await formatarData.paraNumero(pedido.dataEntrega);
    }

    if (pedido.dataNotaFiscal) {
        pedido.dataNotaFiscal = await formatarData.paraNumero(pedido.dataNotaFiscal);
    }

    if (pedido.dataVencimento) {
        pedido.dataVencimento = await formatarData.paraNumero(pedido.dataVencimento);
    }

    var itens = [];
    for (var i = 0; i < pedido.itensPedidoCompra.length; i++) {
        var item = {
            idItemPedidoCompra: pedido.itensPedidoCompra[i].idItemPedidoCompra,
            quantidade: pedido.itensPedidoCompra[i].quantidade, 
            quantidadeCancelada: pedido.itensPedidoCompra[i].quantidadeCancelada,
            quantidadeRecebida: pedido.itensPedidoCompra[i].quantidadeRecebida,
            valorUnitario: pedido.itensPedidoCompra[i].valorUnitario,
            valorUnitarioEntregue: pedido.itensPedidoCompra[i].valorUnitarioEntregue,
        }

        itens.push(item);
    }

    delete pedido.fornecedores;
    pedido.itensPedidoCompra = itens;

    return pedido;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/pedido', { params: parametros });
  },
  obterPorId: id => {
      return Vue.http.get(`/api/pedido/${id}/ObterPedido`)
      .then(response => response.data)
      .then(pedido => normalizarParaVisualizar(pedido));
  },
  obterPorIdRelatorio: id => {
      return Vue.http.get(`/api/pedido/${id}`)
          .then(response => response.data)
          .then(pedido => normalizarParaVisualizar(pedido));
  },
  adicionar: async (pedido, arquivos) => {
      pedido = await normalizarParaSalvar(pedido);
      pedido.arquivos = arquivos;

      pedido = await converterObjetoFormData(pedido);

      return Vue.http.post('/api/pedido', pedido).then(res => res.data.id);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pedido/servico.js